// @flow

import type {
  Theme,
  ACFRowTemplate,
} from '../../../types';

export const getDefaultYPadding = (rowTemplate: ACFRowTemplate, theme: Theme) => {
  switch (rowTemplate) {
    case 'hero':
      return theme.column.hero.padding;

    default:
      return theme.column.padding;
  }
};
